import { render, staticRenderFns } from "./warehouseForm.vue?vue&type=template&id=5de69788&"
import script from "./warehouseForm.vue?vue&type=script&lang=js&"
export * from "./warehouseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de69788')) {
      api.createRecord('5de69788', component.options)
    } else {
      api.reload('5de69788', component.options)
    }
    module.hot.accept("./warehouseForm.vue?vue&type=template&id=5de69788&", function () {
      api.rerender('5de69788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/warehouseForm.vue"
export default component.exports